import { Stack } from "@/components/ui";
import type { SolicitudDetalle } from "@/lib/types";
import { useAuthStore } from "@/lib/auth-store";
import { puedeReintentarCarga } from "@/features/solicitud-detalle/utils/estado-flags";
import { SiguientePasoCTA } from "./SiguientePasoCTA";
import { ReintentarCard } from "./ReintentarCard";
import { CancelarSolicitudCard } from "./CancelarSolicitudCard";

export function DetalleSidebar({ sol }: { sol: SolicitudDetalle }) {
  const user = useAuthStore((s) => s.user);
  const esDueno = user?.id === sol.solicitanteId;
  return (
    <Stack gap="md" className="sticky top-[72px]">
      {esDueno && <SiguientePasoCTA sol={sol} />}
      {esDueno && puedeReintentarCarga(sol.estado) && <ReintentarCard solicitudId={sol.id} />}
      <CancelarSolicitudCard sol={sol} />
    </Stack>
  );
}
